import { FC } from 'react'
import { AlertAlert, AlertAlertType } from './AlertAlert'
import { List, ListType } from './List'

export const Alert: FC & AlertAlertType & ListType = (): JSX.Element => <></>

Alert.Alert = AlertAlert
Alert.List = List
